import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpService } from '../services/http.service';

@Component({
  selector: 'app-main-content',
  templateUrl: './main-content.component.html',
  styleUrls: ['./main-content.component.sass']
})
export class MainContentComponent implements OnInit, OnDestroy {

  text: Array<string> = [];
  textObsSubscr: any;
  contact: boolean;

  constructor(http: HttpService) {
    this.textObsSubscr = http.textObservable().subscribe((data: object) => {

      this.text = [];
      this.contact = false;
      // tslint:disable-next-line: forin
      for (const prop in data) { this.text.push(data[prop]); }

      if (this.text[0] !== undefined && this.text[0] === 'contact') {
        this.contact = true;
        this.text = this.text.slice(1);
      }

    });
  }

  ngOnInit() { }

  ngOnDestroy() {
    this.textObsSubscr.unsubscribe();
  }

}
